import first from "lodash/first";
import React, { createContext, useContext, useMemo } from "react";
import { Variant } from "./enums";
const NewsletterContext = /*#__PURE__*/createContext({
  campaignName: "",
  dataMatrix: {},
  newsletterItems: [],
  queryParametersForSocialButtons: {},
  variant: Variant.Footer
});
export const NewsletterContextProvider = ({
  children,
  multipleNewsletters = false,
  value: {
    newsletterItems,
    ...context
  }
}) => {
  const newsletterItemForDisplay = useMemo(() => first(newsletterItems), [newsletterItems]);
  return /*#__PURE__*/React.createElement(NewsletterContext.Provider, {
    value: {
      ...context,
      newsletterItemForDisplay,
      newsletterItems: multipleNewsletters ? newsletterItems : newsletterItems.slice(0, 1)
    },
    "data-qa": "newsletter-context-provider"
  }, children);
};
NewsletterContext.displayName = "NewsletterContext";
export const useNewsletterContext = () => useContext(NewsletterContext);